import { render, staticRenderFns } from "./CustDataViewPermissionEdit.vue?vue&type=template&id=ce6a82b4&scoped=true"
import script from "./CustDataViewPermissionEdit.vue?vue&type=script&lang=js"
export * from "./CustDataViewPermissionEdit.vue?vue&type=script&lang=js"
import style0 from "./CustDataViewPermissionEdit.vue?vue&type=style&index=0&id=ce6a82b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce6a82b4",
  null
  
)

export default component.exports